import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService } from 'src/app/services/helper.service';
import { SelectsService } from 'src/app/services/selects.service';
import { ChartOptions, HeatMapsService } from 'src/app/pages/payments/services/chart/heat-maps.service';
import { ChartComponent } from "ng-apexcharts";
import { PaymentsService } from '../../../services/payments.service';

@Component({
  selector: 'app-payments-days-hours-chart',
  templateUrl: './payments-days-hours-chart.component.html',
  styleUrls: ['./payments-days-hours-chart.component.scss']
})
export class PaymentsDaysHoursChartComponent implements OnInit {

  public toggleTooltip = false;
  public itemMenuSelected: number;

  public togglePopOver = false;
  public clientX: number;
  public clientY: number;
  public messageTooltip: string;
  public minRange: number = 0;
  public maxRange: number = 0;
  public onlinePaymentsResponse: any[] = [];

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(public helper: HelperService, 
    public selects: SelectsService,
    private heatMap: HeatMapsService,
    private payments: PaymentsService) {
    this.assignOptions(100);
    this.getOnlinePaymentsByDay();
  }

  ngOnInit() {
  }

  assignOptions(maxRange: number) {
    this.heatMap.chartOptions.plotOptions.heatmap.colorScale.ranges[0].to = maxRange;
    this.chartOptions = this.heatMap.chartOptions;
  }

  getOnlinePaymentsByDay() {
    this.payments.getOnlinePaymentsByDay()
      .subscribe(
        (response: any) => {
          // console.log('response -> ', response);
          if (response && response.data && response['data'].length > 0) {
            this.maxRange = response['max'] || 0;
            this.onlinePaymentsResponse = response['data'].map((day: any) => {
              return this.parseResponse(day);
            });
            this.assignOptions(this.maxRange);
            this.chartOptions.series = this.onlinePaymentsResponse;
            return;
          }
          this.onlinePaymentsResponse = [];
        },
        (error: any) => {
          this.onlinePaymentsResponse = [];
          this.chartOptions.series = [];
        }
      );
  }

  parseResponse(day: any) {
    // console.log("day is",day);
    return {
      name: day.day,
      data: day.multi.map((itemMulti: any, idx: number) => (
        {
          x: itemMulti.stringHour,
          y: itemMulti.totalPays,
        }
      ))
    }
  }

  getHeatMap(itemData: any, day: string, hour: number) {
    if (day === itemData.day) {
      return `rgba(76, 175, 80, ${itemData.value})`
    }
  }

}
